import { LottieAnimation } from './LottieAnimation';

interface LottieLoadingSpinnerProps {
  /** Size of the loading spinner */
  size?: number | string;
  /** CSS classes for the container */
  className?: string;
  /** Custom animation data - if not provided, will use a simple loading animation */
  animationData?: object;
}

/**
 * A Lottie-based loading spinner component
 *
 * Uses the default loading animation from /animations/loading.json
 * or falls back to a CSS spinner if no animation is provided.
 */
export function LottieLoadingSpinner({
  size = 64,
  className = '',
  animationData,
}: LottieLoadingSpinnerProps) {
  // Use the provided animation data or default to the loading animation
  if (animationData) {
    return (
      <LottieAnimation
        animationData={animationData}
        width={size}
        height={size}
        className={className}
        loop
        autoplay
      />
    );
  }

  // Use the default loading animation from public folder
  return (
    <LottieAnimation
      path="/animations/loading.json"
      width={size}
      height={size}
      className={className}
      loop
      autoplay
    />
  );
}

export default LottieLoadingSpinner;
